import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import { clearRows } from '../../../Redux/actions/rowActions';
import { useDispatch } from 'react-redux';
import "../pagination/pagination.css"
import { IoAddSharp, IoReturnDownBack } from "react-icons/io5";
import Pagination from '../pagination/pagination';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from '../../services/apiService';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import WindowedSelect from 'react-windowed-select'
import { Modal, Button, Form, Row, Col, Table } from "react-bootstrap";
import { toast } from 'react-toastify';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { ClipLoader } from 'react-spinners';

const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const InstallmentInvoiceListing = () => {
    const [rowData, setRowData] = useState([]);
    const [proprtyList, setProperty] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const { currencyPrecision } = useCurrency();
    const [unitList, setUnitList] = useState([])
    const apiService = new LeaseApiService();
    const [FilterTab, setFilterTab] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const [previewModal, setPreviewModal] = useState(false)
    const [periodFrom, setPeriodFrom] = useState("");
    const [selectedLease, setSelectedLease] = useState();
    const [periodTo, setPeriodTo] = useState("");
    const [postingDate, setPostingDate] = useState("");
    const [contextMenu, setContextMenu] = useState(null);
    const [taxList, setTaxList] = useState([])
    const [loader, setloader] = useState(false);

    let navigate = useNavigate()
    let dispatch = useDispatch()
    const [formData, setFormData] = useState({
        fromDate: "",
        toDate: "",
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }]
    })
    const [creditNote, setCreditNote] = useState({
        postingDate: "",
        amount: "",
        vatRate: "",
        vatAmount: "",
        total: "",
        narration: "",
    })
    const formatDat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        const today = new Date();

        // First day of current month
        const firstDayCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        // First day of next month
        const firstDayNextMonth = new Date(today.getFullYear(), today.getMonth() + 1, -1);

        setPeriodFrom(formatDat(firstDayCurrentMonth));
        setPostingDate(formatDat(firstDayCurrentMonth));
        setPeriodTo(formatDat(firstDayNextMonth));

        const handleClickOutside = () => setContextMenu(null);

        window.addEventListener("click", handleClickOutside);

        return () => window.removeEventListener("click", handleClickOutside);
    }, []);
    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Lease Receipt");
        setPermissions(permissions[0]);
    }, [])
    useEffect(() => {
        getItems();
        fetchDropdownData();
    }, [])
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'ReceiptPropertyNos');
            const res = await apiService.getApiParamater('RECEIPT_DROPDOWN', `?${params.toString()}`);
            setProperty([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.PropertyNo]);
            const duductoinParam = new URLSearchParams();
            duductoinParam.append('Action', 'GetTaxDetails');
            const deductionRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${duductoinParam.toString()}`);
            setTaxList(deductionRes?.data?.result?.data)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handlePrint = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: rowData?.tranId },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                    { name: "ReceiptNo", value: rowData?.invoiceNo },
                    { name: "reportName", value: 'INSTALLMENTINV' },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const handleCNPrint = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "ReceiptNo", value: rowData?.cnVoucherNo },
                    { name: "RecordId", value: "" },
                    { name: "LeaseNo", value: "" },
                    { name: "reportName", value: 'SICREDITNOTE' },
                ];
                debugger
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const handleEdit = (rowData) => {
        setSelectedLease(rowData)
        const selectedVat = taxList?.find(vat => vat?.Description === rowData?.tax);
        setCreditNote({
            ...creditNote,
            amount: rowData?.amount?.toFixed(currencyPrecision?.decimalNumbers),
            vatRate: [{ label: selectedVat?.Description, value: selectedVat }],
            total: rowData?.total?.toFixed(currencyPrecision?.decimalNumbers),
            vatAmount: rowData?.vat?.toFixed(currencyPrecision?.decimalNumbers),
            // narration: (rowData?.description),
        });
        setPreviewModal(true);
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoading(true);
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', 50);
            params.append('PropertyNo', formData?.Proprty?.value?.value || 'All');
            params.append('UnitNo', formData?.unitNo?.label || 'All');
            params.append('Mode', 'EDIT');
            params.append('TenantNo', 'All');
            params.append('LeaseNo', 'All');
            params.append('UnitType', 'All');
            params.append('FromDate', periodFrom);
            params.append('ToDate', periodTo);

            const res = await apiService.getApiParamater('GET_INSTALL_INVOICE_LIST', `?${params.toString()}`);
            // let gridData = res?.data?.result?.filter((temp) => temp?.tranId != 0);
            // let gridData = res?.data?.result?.filter((temp) => temp?.tranId != 0)?.sort((a, b) => a.tranId - b.tranId); accending
            let gridData = res?.data?.result?.filter((temp) => temp?.tranId != 0)?.sort((a, b) => b.tranId - a.tranId);
            setRowData(gridData || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const SearchItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoading(true);
            const params = new URLSearchParams();
            params.append('PageNo', 1);
            params.append('PageSize', 50);
            params.append('PropertyNo', formData?.Proprty?.value?.value || 'All');
            params.append('UnitNo', formData?.unitNo?.label || 'All');
            params.append('Mode', 'EDIT');
            params.append('TenantNo', 'All');
            params.append('LeaseNo', 'All');
            params.append('UnitType', 'All');
            params.append('FromDate', periodFrom);
            params.append('ToDate', periodTo);

            const res = await apiService.getApiParamater('GET_INSTALL_INVOICE_LIST', `?${params.toString()}`);
            let gridData = res?.data?.result?.filter((temp) => temp?.tranId != 0)?.sort((a, b) => b.tranId - a.tranId);
            setRowData(gridData || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const numberValueFormatter = function (params) {
        return params?.value;
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const handleMenuAction = (action, rowData) => {
        if (action === 'creditNote') {
            handleEdit(rowData);
        } else if (action === 'print') {
            handlePrint(rowData);
        } else if (action === 'CNprint') {
            handleCNPrint(rowData);
        }
        setContextMenu(null); // Close the menu
    };
    const columnDefs = [
        {
            headerName: '', field: 'recordId', cellRenderer: BtnCellRenderer, pinned: 'left',
            cellRendererParams: {
                clicked: function (field, exp2) {
                    handleMenuAction(field, exp2);
                },
            }, width: 30,
        },
        {
            headerName: 'Lease No', field: 'leaseNo', filter: true,
            floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 140, pinned: 'left'
        },
        {
            headerName: "lease Start", field: "leaseStart", filter: true, floatingFilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        {
            headerName: "leaseEnd", field: "leaseEnd", filter: true, floatingFilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        {
            headerName: 'Invoice No', field: 'invoiceNo', filter: true, floatingFilter: true, suppressMovable: true, width: 150,
            // valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
        {
            headerName: "Invoice Date", field: "invoiceDate", filter: true, floatingFilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        {
            headerName: "Narration", field: "description", filter: true, floatingFilter: true, suppressMovable: true, width: 300
        },
        {
            headerName: 'Tenant Name', field: 'tenantName', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 300
        },
        {
            headerName: 'Property Name', field: 'propertyName',
            valueFormatter: numberValueFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 200
        },
        {
            headerName: 'Unit No', field: 'unitNo', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 120
        },
        {
            headerName: 'Amount', field: 'amount', filter: true, floatingFilter: true, suppressMovable: true, width: 150,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
    ]
    const clearAllRows = () => {
        dispatch(clearRows());
    }
    const handlenew = () => {
        clearAllRows();
        navigate("/Property/Management/Installment/Invoice")
    }
    const handleClearFilters = () => {
        setFormData({
            receiptNo: "",
            Proprty: [{ label: 'Select Property', value: '' }],
            Status: [{ label: 'All', value: '' }],
        });
    }
    const handlePropertyChange = async (selectedOption) => {
        if (selectedOption?.value?.value === "All") {
            setFormData({
                ...formData,
                Proprty: selectedOption,
                unitNo: [{ label: '', value: '' }]
            });
        } else {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LIISerUnitsByPropId');
            params.append('CascadValue', selectedOption?.value?.value);
            const res = await apiService.getApiParamater('GET_INSTALL_INVOICE_CASCAD', `?${params.toString()}`);
            setUnitList([{ value: 'All', text: 'All' }, ...res?.data?.items]);
            setFormData({
                ...formData,
                Proprty: selectedOption,
                unitNo: [{ label: '', value: '' }]
            });
        }

    }
    const handleUitNo = (selectedOption) => {
        setFormData({ ...formData, unitNo: selectedOption });
    }
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handlePeriodFromChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodFrom(formattedDate);
    }
    const handlePeriodToChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodTo(formattedDate);
    }
    const handleChange = (key, value) => {
        let updatedData = { ...creditNote, [key]: value };
        if (key === "amount") {
            const amount = parseFloat(key === "amount" ? value : creditNote.amount);
            let vatRate = creditNote?.vatRate?.value?.Rate || 0
            const vatAmt = (amount * vatRate) / 100;
            let vatAmount = vatAmt?.toFixed(currencyPrecision?.decimalNumbers)
            const total = (amount + vatAmt)?.toFixed(currencyPrecision?.decimalNumbers);
            updatedData = { ...updatedData, vatAmount, total };
        } else if (key === "vatRate") {
            const amount = parseFloat(creditNote.amount);
            let vatRate = value?.value?.Rate || 0
            const vatAmt = (amount * vatRate) / 100;
            let vatAmount = vatAmt?.toFixed(currencyPrecision?.decimalNumbers)
            const total = (amount + vatAmt)?.toFixed(currencyPrecision?.decimalNumbers);
            updatedData = {
                ...updatedData,
                vatAmount,
                total
            };
        }

        setCreditNote(updatedData);
    }
    const handleSave = async () => {
        if (!creditNote?.narration) {
            toast.warning("Please Enter Narration")
            setloader(false);
            return
        }
        const Invoice = new URLSearchParams();
        Invoice.append('Action', 'chkPostingDateInFinYear');
        Invoice.append('FromDate', postingDate);

        const Invoiceres = await apiService.getApiParamater('GET_INSTALL_INVOICE_COMMON', `?${Invoice.toString()}`);
        let result = Invoiceres?.data?.result?.data
        if (result?.length === 0) {
            toast.warning("Posting Date should be between Financial Year..!!")
            setloader(false);
            return
        } else {
            const body = {
                siCreditNoteMain: {
                    invoiceNo: selectedLease?.invoiceNo,
                    leaseNo: selectedLease?.leaseNo,
                    groupID: selectedLease?.groupId,
                    postingDate: postingDate,
                    creditAmt: parseFloat(creditNote?.amount),
                    vatAmt: parseFloat(creditNote?.vatAmount),
                    totalAmt: parseFloat(creditNote?.total),
                    narration: creditNote?.narration,
                    vatDesc: creditNote?.vatRate?.value?.Description || creditNote?.vatRate[0]?.value?.Description,
                    psdid: selectedLease?.psdId,
                    taxCode: creditNote?.vatRate?.value?.RecordId || creditNote?.vatRate[0]?.value?.RecordId
                }
            };
            const postRes = await apiService.post("POST_CREDIT_NOTE", body);
            debugger
            if (postRes?.data?.statusCode === 200 || postRes?.data?.statusCode === 201) {
                getItems()
                toast.success(postRes?.data?.message)
                setPreviewModal(false);
                setCreditNote({
                    postingDate: "",
                    amount: "",
                    vatRate: "",
                    vatAmount: "",
                    total: "",
                    narration: "",
                });
                setloader(false);
            } else {
                toast.warning(postRes?.data?.message)
                setloader(false);
            }
            setloader(false);
        }
    }
    const handlePostingDate = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPostingDate(formattedDate);
    }
    return (
        <div className='p-3 '>
            <div className="cost-center-section">
                <div className="d-flex  cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className='row'>
                            <div className='col-4'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.Proprty}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    options={proprtyList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='col-4'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.unitNo}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                    options={unitList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='col d-flex gap-2'>
                                <div
                                    onClick={() => SearchItems()}
                                    className='mainbtnGry flex-end gap-2 w-50'>
                                    <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Search</div>
                                </div>
                                <div
                                    onClick={() => handleClearFilters()}
                                    className='mainbtnRed flex-end gap-2 w-50'>
                                    <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Reset</div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-4 d-flex gap-3'>
                                <label className='center w-25'>From Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={periodFrom}
                                    onChange={(date) => handlePeriodFromChange({ name: 'leaseDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className='col-4 d-flex gap-3'>
                                <label className='center w-25'>LeaseExpiry</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={periodTo}
                                    onChange={(date) => handlePeriodToChange({ name: 'toDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-4'>
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className='d-flex justify-contant-between '>
                            <h5 className='col mainInvHead'>Installment Invoice List</h5>
                            <div className='d-flex justify-content-end gap-1'>
                                {/* {permissions?.canAdd === true ? */}
                                <div className='col center'>
                                    <button className='mainbtn ' type="submit" onClick={() => handlenew()}>
                                        <IoAddSharp color='#fff' className='center mt-1' /> <div>Add</div>
                                    </button>
                                </div>
                                {/* } */}
                            </div>
                        </div>
                        <div className='gridshad  mt-3'>
                            <div className="ag-theme-quartz" style={{ height: 510 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: '#F0EDF5' };
                                        } else {
                                            return { background: '#fff' };
                                        }
                                    }}
                                    rowData={rowData}
                                    columnDefs={columnDefs}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    frameworkComponents={{ BtnCellRenderer }}
                                    context={{ setContextMenu }}
                                />
                            </div>
                            <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                        </div>
                    </>
                )}
            </div>
            {contextMenu && (
                <div
                    style={{
                        position: 'absolute',
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        zIndex: 1000,
                        padding: '10px 30px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                    }}
                >
                    <div style={{ display: 'grid' }}>
                        <button className="btn btn-secondary " onClick={() => handleMenuAction('print', contextMenu.data)}>
                            Invoice Print
                        </button>
                        {contextMenu?.data?.isCreditNoteMade === false ?
                            <button className="btn btn-secondary mt-2" onClick={() => handleMenuAction('creditNote', contextMenu.data)}>
                                Credit Note
                            </button> :
                            <button className="btn btn-secondary mt-2 " onClick={() => handleMenuAction('CNprint', contextMenu.data)}>
                                Credit Note Print
                            </button>}
                    </div>
                </div>
            )}
            <Modal
                show={previewModal}
                size="lg"
                onHide={() => setPreviewModal(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Credit Note</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {/* Lease Invoice Details Table */}
                    <div className="border p-3 rounded bg-light mb-3">
                        <h6 className="fw-bold mb-3">Lease Invoice Details</h6>
                        <Table bordered size="sm">
                            <tbody>
                                <tr>
                                    <td><strong>Tenant</strong></td>
                                    <td>{selectedLease?.tenantName}</td>
                                    <td><strong>Lease No</strong></td>
                                    <td>{selectedLease?.leaseNo}</td>
                                    <td><strong>Amount</strong></td>
                                    <td>{selectedLease?.amount?.toFixed(currencyPrecision?.decimalNumbers)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Property</strong></td>
                                    <td>{selectedLease?.propertyName}</td>
                                    <td><strong>Invoice No</strong></td>
                                    <td>{selectedLease?.invoiceNo}</td>
                                    <td><strong>VAT</strong></td>
                                    <td>{selectedLease?.vat?.toFixed(currencyPrecision?.decimalNumbers)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Unit No</strong></td>
                                    <td>{selectedLease?.unitNo}</td>
                                    <td><strong>Invoice Date</strong></td>
                                    <td>{selectedLease?.invoiceDate}</td>
                                    <td><strong>Invoice Total</strong></td>
                                    <td>{selectedLease?.total?.toFixed(currencyPrecision?.decimalNumbers)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Description</strong></td>
                                    <td colSpan={5}>{selectedLease?.description}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                    <Form>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Label>Posting Date *</Form.Label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={postingDate}
                                    onChange={(date) => handlePostingDate({ name: 'postingDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={3}>
                                <Form.Label>Amount *</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="amount"
                                    className="form-control"
                                    value={creditNote.amount}
                                    onChange={(e) => handleChange("amount", e.target.value)}
                                />
                            </Col>

                            <Col md={3}>
                                <Form.Label>Tax Code</Form.Label>
                                <WindowedSelect
                                    className="w-100  p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',

                                                color: '#000',
                                            },
                                        }),
                                    }}

                                    value={creditNote.vatRate}
                                    onChange={(selectedOption) => handleChange("vatRate", selectedOption)}
                                    options={taxList?.map((rec) => ({ value: rec, label: rec?.Description }))}
                                />
                            </Col>

                            <Col md={3}>
                                <Form.Label>VAT</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="form-control"
                                    name="vatAmount"
                                    value={creditNote.vatAmount}
                                    readOnly
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label>Total</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="form-control"
                                    name="total"
                                    value={creditNote.total}
                                    readOnly
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Label>Narration *</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    maxLength={950}
                                    name="narration"
                                    value={creditNote.narration}
                                    onChange={(e) => handleChange("narration", e.target.value)}
                                    placeholder="Max 950 characters only..."
                                />
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <div onClick={() => setPreviewModal()} className='mainbtnRed flex-end my-2 gap-2'>
                        <div className='center'>Close</div>
                    </div>
                    {loader === false ?
                        <button className='mainbtn ' type="submit" onClick={() => handleSave()}>
                            <div>Save</div>
                        </button> :
                        <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button>
                    }
                </Modal.Footer>
            </Modal>
        </div>
    );
};

class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // Prevent row selection
        const { context, data } = this.props;

        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.clientX,
                mouseY: e.clientY,
                data: data
            });
        }
    }

    render() {
        return (
            <div className='center'>
                <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '30px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}
export default InstallmentInvoiceListing;